import { HubConnectionBuilder, HubConnection, LogLevel, HttpTransportType } from '@aspnet/signalr'
import config from '@/config';
import Auth from './Auth';
import EventBus from '@/components/core/EventBus'

export default class SignalRClient {

  private connect!: HubConnection;

  private mHubPath: string = "";

  private reconnectionCount: number = 0;

  private eventBus = new EventBus();

  constructor(hubPath: string = '/signalr') {
    this.mHubPath = hubPath;
  }

  public Init() {
    if (this.connect && this.connect.state && this.connect.state === 1) {
      return;
    }
    this.connect = new HubConnectionBuilder()
      .configureLogging(LogLevel.None)
      .withUrl(`${config.baseUrl}${this.mHubPath}`,{accessTokenFactory:()=>Auth.getToken()})
      .build();
    this.connect.on('getNotification', notification => {
      this.eventBus.trigger(notification.Channel, notification.Data);
    });

    // 连接服务器
    this.connect.start().then(() => {
      this.reconnectionCount = 0;
      console.log(`signalr connection '${this.mHubPath}' success`);
    }).catch(err => {
      console.log(`signalr connection '${this.mHubPath}' failure`);
      console.log(`failed info:${err}`);
    });

    // 如果signalr断开连接 5秒尝试重连一次,总共尝试20次
    this.connect.onclose(() => {
      if (this.reconnectionCount < 20) {
        this.reconnectionCount++;
        setTimeout(() => {
          this.connect.start().then(() => {
            this.reconnectionCount = 0;
            console.log(`signalr reconnection '${this.mHubPath}' success`);
          }).catch(err => {
            console.log(`signalr reconnection '${this.mHubPath}' failure`);
            console.log(`failure info:${err}`);
          });
        }, 5000);
      }
    })
  }

  /**
   * 监听signalr信息
   * @param channel 订阅标识
   * @param callback 回调
   */
  public on(channel, callback) {
    this.eventBus.on(channel, callback)
  }
}
